<template>
    <rkm-overlay>
        <rkm-layout-body title="Atendimento de triagem">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
import List from '@/components/pronto-atendimento/atendimento-triagem/List'

export default {
    components: { List },
}
</script>